<template>
  <div id="app">
    <router-view />
    <SessionWarningModal ref="sessionModal" @session-extended="onSessionExtended" />
    <NotificationSystem position="top-right" />
  </div>
</template>

<script>
import SessionWarningModal from '@/components/SessionWarningModal.vue'
import NotificationSystem from '@/components/NotificationSystem.vue'
import sessionManager from '@/services/sessionManager'
import { estaAutenticado } from '@/services/servicioAutenticacion'
import router from '@/router'

export default {
  name: 'ClientApp',
  components: {
    SessionWarningModal,
    NotificationSystem
  },
  data() {
    return {
      showTestButton: false
    }
  },
  mounted() {
    if (!estaAutenticado()) {
      this.onSessionExpired()
      return
    }

    this.initializeSessionMonitoring()

    window.addEventListener('session-warning', this.showSessionWarning)
    window.addEventListener('session-expired', this.onSessionExpired)
  },

  beforeUnmount() {
    window.removeEventListener('session-warning', this.showSessionWarning)
    window.removeEventListener('session-expired', this.onSessionExpired)
  },

  methods: {
    initializeSessionMonitoring() {
      if (estaAutenticado()) {
        sessionManager.startMonitoring(
          () => window.dispatchEvent(new CustomEvent('session-warning')),
          () => window.dispatchEvent(new CustomEvent('session-expired'))
        )
      }
    },

    showSessionWarning() {
      this.$refs.sessionModal.show()
    },

    onSessionExtended() {
      sessionManager.extendSession()
    },

    onSessionExpired() {
      if (router.currentRoute.value.path !== '/iniciar-sesion') {
        router.push('/iniciar-sesion')
      }
    }
  },

  watch: {
    '$route'(to, from) {
      if (from.path === '/iniciar-sesion' && to.path !== '/iniciar-sesion' && estaAutenticado()) {
        this.initializeSessionMonitoring()
      }

      if (to.path === '/iniciar-sesion') {
        sessionManager.stopMonitoring()
      }

      if (to.path !== '/iniciar-sesion' && estaAutenticado()) {
        setTimeout(() => {
          if (!sessionManager.isMonitoring) {
            this.initializeSessionMonitoring()
          }
        }, 100)
      }
    }
  }
}
</script>



